import { Check, Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { useCopiedFeedback } from '@/Domain/hooks/App/useCopiedFeedback.hook';
import { copyToClipboard } from '@/Domain/utils/copyToClipboard';

type Props = {
  code: Record<string, unknown> | string;
};

export const Snippet = ({ code }: Props) => {
  const { t } = useTranslation('common');
  const { copied, markCopied } = useCopiedFeedback();

  const jsonString = typeof code === 'string' ? code : JSON.stringify(code, null, 2);

  return (
    <div className="flex items-center gap-2 bg-foreground text-white p-3 rounded-lg w-full">
      <pre className="flex-1 min-w-0 text-xs leading-4 overflow-x-auto">
        <code>{jsonString}</code>
      </pre>
      <Button
        size="xs"
        className={`shrink-0 bg-white/10 text-white hover:bg-white/20 ${
          copied ? 'pointer-events-none' : ''
        }`}
        variant="custom"
        onClick={() => !copied && copyToClipboard(jsonString, markCopied)}
      >
        {copied ? (
          <>
            <Check />
            {t('copied')}
          </>
        ) : (
          <>
            <Copy />
            {t('copy')}
          </>
        )}
      </Button>
    </div>
  );
};
